module.exports = __webpack_public_path__ + "img/the-herons-court-2.f438a27a.webp";